import { FIELD_ACTIONS, type FieldAction } from './fields';
import { GLOBAL_ACTIONS, type GlobalAction } from './global';
import { SUBMISSION_ACTIONS, type SubmissionAction } from './submission';

export * from './fields';
export * from './global';
export * from './submission';

export const FORM_SUBMITTER_ACTIONS = {
  ...GLOBAL_ACTIONS,
  ...FIELD_ACTIONS,
  ...SUBMISSION_ACTIONS,
} as const;

export type FormSubmitterAction = GlobalAction | FieldAction | SubmissionAction;

export type FormSubmitterDispatch = (action: FormSubmitterAction) => void;
